import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
} from "@material-ui/core";
import * as React from "react";
import EditIcon from "@material-ui/icons/Edit";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    chip: {
      margin: theme.spacing(0.5),
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  title: any;
  item: any;
  index: any;
  onChipDelete: any;
  onChipEdit: any;
  subTitle?: any;
  chipValue?: any;
  isDisabled?: any;
  ownEditDialog?: any;
}
class ChipComponent extends React.Component<Props> {
  state = {
    openConfimDelete: false,
    openEditDialog: false,
    editValue: "",
  };

  componentDidMount = () => {
    const { item } = this.props;
    this.setState({
      editValue: item.label ? item.label : item.title ? item.title : "",
    });
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    const { item } = this.props;
    if (prevProps.item !== item) {
      this.setState({
        editValue: item.label ? item.label : item.title ? item.title : "",
      });
    }
  };

  renderConfirmationDialog = () => {
    const { item, title, subTitle, index, onChipDelete } = this.props;
    let mTitle = "";
    if (title instanceof Object) {
      mTitle = subTitle;
    } else {
      mTitle = title;
    }
    return (
      <Dialog
        fullWidth={true}
        open={this.state.openConfimDelete}
        onClose={() =>
          this.setState({
            openConfimDelete: false,
          })
        }
      >
        <DialogTitle id="alert-dialog-title">{`Deleting ${mTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure want to delete ${mTitle}.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              this.setState({
                openConfimDelete: false,
              })
            }
            color="primary"
          >
            No
          </Button>
          <Button
            onClick={() => {
              this.setState({ openConfimDelete: false }, () => {
                onChipDelete(item, index);
              });
            }}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  renderEditDialog = () => {
    const { item, title, subTitle, index, onChipEdit } = this.props;
    let mTitle = "";
    if (title instanceof Object) {
      mTitle = subTitle;
    } else {
      mTitle = title;
    }
    return (
      <Dialog
        fullWidth={true}
        open={this.state.openEditDialog}
        onClose={() =>
          this.setState({
            openEditDialog: false,
          })
        }
      >
        <DialogTitle id="alert-dialog-title">{`Editing ${mTitle}`}</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            id="standard-basic"
            label="Inspection Categories"
            value={this.state.editValue}
            placeholder="Add Inspection category"
            onChange={(event: any) => {
              this.setState({
                editValue: event.target.value,
              });
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              this.setState({
                openEditDialog: false,
              });
            }}
            color="primary"
          >
            No
          </Button>
          <Button
            onClick={() => {
              this.setState({ openEditDialog: false }, () => {
                let mItem = item;
                if (mItem.label) {
                  mItem.label = this.state.editValue;
                  mItem.value = this.state.editValue.includes("-")
                    ? this.state.editValue.toUpperCase()
                    : this.state.editValue.replace(" ", "-").toUpperCase();
                }
                if (item.title) {
                  mItem.title = this.state.editValue;
                  mItem.value = this.state.editValue.includes("-")
                    ? this.state.editValue.toUpperCase()
                    : this.state.editValue.replace(" ", "-").toUpperCase();
                }
                onChipEdit(mItem, index);
              });
            }}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  render() {
    const {
      classes,
      item,
      index,
      isDisabled,
      title,
      ownEditDialog,
    } = this.props;
    return (
      <React.Fragment>
        <Chip
          key={index.toString()}
          className={classes.chip}
          label={title}
          disabled={isDisabled ? true : false}
          avatar={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IconButton
                onClick={() => {
                  if (ownEditDialog) {
                    ownEditDialog(item, index);
                  } else {
                    this.setState({
                      openEditDialog: true,
                    });
                  }
                }}
              >
                <EditIcon
                  style={{
                    width: 15,
                    height: 15,
                  }}
                  fontSize={"small"}
                />
              </IconButton>
            </div>
          }
          onDelete={() =>
            this.setState({
              openConfimDelete: true,
            })
          }
        />
        {this.renderEditDialog()}
        {this.renderConfirmationDialog()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ChipComponent);
